import Confetti from "react-confetti";

import powerBulbImage from "../../Assets/Images/su-power-bulb.png";
import wifiCheckImage from "../../Assets/Images/su-wifi-check.png";
import { useViewport } from "../../Contexts/ViewportContext";
import CheckBadge from "./check-badge";
import PrimaryButton from "./primary-button";
import { formatMoney } from "./utilities-config";

export default function Celebration({ amount, total, powerAmount, homeAmount, onContinue, onMakeMore }) {
  const { width, height } = useViewport();
  const showUtilities = Boolean(onMakeMore && total);
  return (
    <section className="su-hero su-hero--celebrate">
      <div className="su-confetti" aria-hidden="true">
        <Confetti width={width} height={height} />
      </div>
      {showUtilities ? (
        <>
          <h1 className="su-display">
            YOUR <span>{amount}</span> IS READY NOW.
            <br />
            WANT TO MAKE IT <span>{total}</span>?
          </h1>
          <p className="su-hero-copy">Access your {amount} instantly, or continue one-time setup to earn even more.</p>
          <div className="su-offers">
            <div className="su-offer">
              <div className="su-offer-art">
                <img src={powerBulbImage} alt="" />
              </div>
              <div className="su-offer-row">
                <strong>Stake Power</strong>
                <b>+{formatMoney(powerAmount)}</b>
              </div>
              <span>Set up in one click. 1 minute.</span>
            </div>
            <div className="su-offer">
              <div className="su-offer-art">
                <img src={wifiCheckImage} alt="" />
              </div>
              <div className="su-offer-row">
                <strong>Stake TV and Internet</strong>
                <b>Up to {formatMoney(homeAmount)}</b>
              </div>
              <span>Booked by a concierge. 1 minute.</span>
            </div>
          </div>
          <div className="su-hero-actions">
            <PrimaryButton onClick={onMakeMore}>Continue setup</PrimaryButton>
            <button className="su-link su-link--light" type="button" onClick={onContinue}>
              No thanks, show me my money!
            </button>
          </div>
        </>
      ) : (
        <>
          <CheckBadge size={64} />
          <h1 className="su-display">
            {amount ? (
              <>
                <span>{amount}</span> IS IN.
              </>
            ) : (
              "YOU'RE IN."
            )}
          </h1>
          <p className="su-hero-copy">Your account is open and your {amount || "cash back"} is ready to spend, save, or cash out.</p>
          <PrimaryButton onClick={onContinue}>{amount ? `Show me my ${amount}` : "Go to my account"}</PrimaryButton>
        </>
      )}
    </section>
  );
}
